import { render } from "./WebMockup.vue?vue&type=template&id=188cec2d&scoped=true"
import script from "./WebMockup.vue?vue&type=script&lang=ts"
export * from "./WebMockup.vue?vue&type=script&lang=ts"

import "./WebMockup.vue?vue&type=style&index=0&id=188cec2d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-188cec2d"

export default script